import * as Sentry from '@sentry/vue';
import router from '@/router';
import {getEnvMode, isProduction} from '@/utils/env';
import {d} from '@/utils/consoleHelper.ts';

const IS_DEBUG = !isProduction();

export function initSentry(app: any) {
    const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || 'https://477434e9051c46e38a6d5052ba4129d7@sentry.io/2158517';

    if (!SENTRY_DSN) {
        d.warn('⚠️ Sentry DSN is not provided.');
        return;
    }

    Sentry.init({
        app,
        dsn: SENTRY_DSN,
        release: import.meta.env.VITE_APP_VERSION || '1.0.52',
        // debug: IS_DEBUG,
        environment: getEnvMode(),

        beforeSend: (event, hint) => {
            if (IS_DEBUG) {
                d.error('[Sentry Debug] Captured Error:', hint.originalException || hint.syntheticException);
                // return null; // this drops the event and nothing will be sent to sentry
            }
            return event;
        },

        integrations: [
            Sentry.vueIntegration({
                tracingOptions: {
                    trackComponents: true,
                },
            }),
            Sentry.browserTracingIntegration({router}),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: true,
            }),
            // The following is all you need to enable canvas recording with Replay
            Sentry.replayCanvasIntegration(),
        ],

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: IS_DEBUG ? 1.0 : 0.1,

        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', 'fleetwire.test', 'fleetwire.io', /^\//],
    });

    d.log('✅ Sentry Initialized Successfully!');
}